import { merge } from 'lodash';

const defaultArgs = {};

const defaultAttrs = {
  address: true,
  boostDecimals: true,
  boostRatio: true,
  boostStaked: true,
  id: true,
  lpStaked: true,
  pid: true
};

export default (args = {}, attrs = {}) => ({
  userInfos: {
    __args: merge({}, defaultArgs, args),
    ...merge({}, defaultAttrs, attrs)
  }
});
